module.exports = __webpack_public_path__ + "static/img/image-red.e90e3707.svg";